module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main-page/main-page.component.scss
// module id = ./src/app/main-page/main-page.component.scss
// module chunks = main